import { getQueryParams } from "@/utils";
import Vue from "vue";
import VueI18n from "vue-i18n";


Vue.use(VueI18n);

export const LOCALE_LANG_KEY = "languageLocale";
export let DEFAULT_LANG = (
  navigator.browserLanguage || navigator.language
).toLowerCase();

if (!DEFAULT_LANG) {
  DEFAULT_LANG = "en";
}
if (DEFAULT_LANG.startsWith("zh")) {
  DEFAULT_LANG = "zh-cn";
} else if (DEFAULT_LANG.startsWith("en-")) {
  DEFAULT_LANG = "en";
} else if (DEFAULT_LANG.startsWith("ko")) {
  DEFAULT_LANG = "ko";
}
function deepAssign() {
  let name, options, src, copy;
  let length = arguments.length;
  // 记录要复制的对象的下标
  let i = 1;
  // target默认是第一个参数
  let target = arguments[0] || {};
  // 如果target不是对象，我们是无法进行复制的，所以设为{}
  if (typeof target !== "object") {
    target = {};
  }
  // 循环遍历要复制的对象
  for (; i < length; i++) {
    // 获取当前对象
    options = arguments[i];
    // 要求不能为空 避免extend(a,,b)这种情况
    if (options != null) {
      for (name in options) {
        // 目标属性值
        src = target[name];
        // 要复制的对象的属性值
        copy = options[name];

        if (copy && typeof copy == "object") {
          // 递归调用
          target[name] = deepAssign(src, copy);
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }

  return target;
}

let jsonFiles = {
  en: require.context("./en", true, /\.json$/),
  zh: require.context("./zh", true, /\.json$/),
  ko: require.context("./ko", true, /\.json$/),
};

function loadLangDir(langKey) {
  let langJSONFiles = jsonFiles[langKey];
  let destJSONObj = {};
  langJSONFiles.keys().forEach((moduleItem) => {
    destJSONObj = deepAssign(destJSONObj, langJSONFiles(moduleItem));
  });

  return destJSONObj;
}

const locales = {
  en: deepAssign(require("./en.json"), loadLangDir("en")),
  zh: deepAssign(require("./zh.json"), loadLangDir("zh")),
  ko: deepAssign(require("./ko.json"), loadLangDir("ko")),
};
locales["zh-cn"] = locales.zh;
locales["zh-tw"] = locales.zh;

export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
});

//////////////
// 判断是否开启调试模式（url特定参数下）
const debugMode =getQueryParams().get("debugALinkOneLang");

// 自定义 t 函数包装器
function createDebugT(originalT) {
  return (key, ...args) => {
    const value = originalT(key, ...args);
    // 防止嵌套重复包裹
    if (typeof value === "string" && !value.startsWith("[")) {
      return `[${key}] ${value}`;
    }
    return value;
  };
}

// 替换全局 $t 方法（非生产环境） — 兼容 Vue2(vue-i18n v8)
if (debugMode) {
  // 在 Vue2 中没有 i18n.global，使用 i18n.t 并确保绑定到 i18n 实例
  const originalT = i18n.t
    ? i18n.t.bind(i18n)
    : (key, ...args) => Vue.prototype.$t(key, ...args);
  const debugT = createDebugT(originalT);
  // 覆盖 i18n 实例的 t 方法
  i18n.t = debugT;
  // 覆盖 Vue.prototype.$t，确保组件内调用 this.$t 也使用调试包装
  if (Vue && Vue.prototype) {
    Vue.prototype.$t = function (key, ...args) {
      return debugT(key, ...args);
    };
  }
}
////////////////////////////////
i18n.setup = (lang) => {
  if (!lang) {
    lang = window.localStorage.getItem(LOCALE_LANG_KEY);
  }

  lang = lang ? lang.toLowerCase() : DEFAULT_LANG;

  if (!locales[lang]) {
    lang = "en";
  }

  i18n.locale = lang;
};

i18n.current = () => {
  return window.localStorage.getItem(LOCALE_LANG_KEY);
};

i18n.fixCategoryMultiLang = (data) => {
  let curLang = window.localStorage.getItem(LOCALE_LANG_KEY);

  if (curLang != "zh") {
    data.forEach((ctg) => {
      if (ctg.multiLang && ctg.multiLang.length > 0) {
        let ml = JSON.parse(ctg.multiLang);

        if (curLang == "en" && ml.en && ml.en.length > 0) {
          ctg.categoryName = ml.en;
        } else if (curLang == "ko" && ml.ko && ml.ko.length > 0) {
          ctg.categoryName = ml.ko;
        }
      }
    });
  }
};

i18n.fixCategoryChildrenMultiLang = (data) => {
  let curLang = window.localStorage.getItem(LOCALE_LANG_KEY);

  if (curLang != "zh") {
    data.forEach((ctg) => {
      if (ctg.multiLang && ctg.multiLang.length > 0) {
        let ml = JSON.parse(ctg.multiLang);

        if (curLang == "en" && ml.en && ml.en.length > 0) {
          ctg.categoryName = ml.en;
        }
        if (curLang == "ko" && ml.en && ml.en.length > 0) {
          ctg.categoryName = ml.ko;
        }
      }
      if (ctg.categories && ctg.categories.length > 0) {
        i18n.fixCategoryChildrenMultiLang(ctg.categories);
      }
    });
  }
};

i18n.setup();
window.i18n = i18n;

export default i18n;
